import React from 'react';

import style from './Transform.module.scss';

export default function TransformColumn(props) {
  const { children, ...rest } = props;
  return (<span className={style.col} {...rest}>{children}</span>);
}
